<p-table id="vendorTable" #table [value]="dashboards()" [paginator]="true" [rows]="50"      
        sortMode="multiple" [showCurrentPageReport]="true" [rowsPerPageOptions]="[5, 10, 20]"
        class="w-full rounded-xl h-full" [scrollable]="true" scrollHeight="flex">
    
        <ng-template pTemplate="header">
          <tr class="bg-gray-100 text-sm text-left">
            <th pSortableColumn="id">ID Dashboard</th>
            <th pSortableColumn="name">Bezeichnung</th>
            <th pSortableColumn="name">Beschreibung</th>    
            <th pSortableColumn="name">Erstellt am</th>    
            <th style="width: 10rem" class="justify-center"></th>              
        </ng-template>
        <ng-template pTemplate="body" let-dashboard>
          <tr class="hover:bg-gray-50 text-sm">
            <td>{{ dashboard.id }}</td>
            <td>{{ dashboard.name }}</td>
            <td>{{ dashboard.description }} </td>
            <td>{{ dashboard.createdAt | date:'dd.MM.yyyy'}} </td>
            <td class="flex justify-center">
              @if (managementEnabled) {
                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [outlined]="true" (click)="editDashboard(dashboard)" />
                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" (click)="deleteDashboard(dashboard)" />
              }
          </td>
          </tr>
        </ng-template>
      </p-table>

      <p-confirmDialog></p-confirmDialog>
